import * as React from 'react'

function SvgFunVeiwList(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M19 17a1 1 0 010 2H9a1 1 0 010-2h10zM5 17a1 1 0 110 2 1 1 0 010-2zm0-6a1 1 0 11.001 2 1 1 0 010-2zm14 0a1 1 0 010 2H9a1 1 0 010-2h10zm0-6a1 1 0 010 2H9a1 1 0 110-2h10zM5 5a1 1 0 110 2 1 1 0 010-2z" />
    </svg>
  )
}

export default SvgFunVeiwList
